import { gql } from "@apollo/client";

export const CREATE_ELIGIBILITY_MUTATION = gql`
  mutation CreateEligibilityMutation($data: EligibilityInputData!) {
    createEligibility(data: $data) {
      id
      orgId
      situation
      autoScreen
    }
  }
`;
